import maxestates from "../../../../public/projects/max/images/maxestate360.webp";
import logo from "../../../../public/projects/max/images/logo/logo.png"
export const developersMax = {
  name: `Max Estates Properties in Gurugram`,
  properties: [
    {
      name: "Max Estates - 360",
      image: maxestates,
      price: "On Request",
      location: "Sector 36A",
      developer:"Max",
      state:"Gurugram",
      projectlocation:"Dwarka Expressway",
      bed: "1 - 3BHK",
      size: "....",
      url: ``,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};


export const Headers={
  logo:logo,
  data:
    {
      experience:`2016`,
      projects:`118`,
      ongoingprojects:`18`
    },
  about:`Max Estates aspires to build sustainable, grade A developments in Delhi NCR, with a 
  focus on well-being. We have paid close attention to creating a unique confluence of spaces that enable 
  collaboration, innovation and community, that are not just functional and aesthetically pleasing, but 
  environmentally sustainable, and designed to promote the holistic wellness of their users. Our current and 
  planned developments are diversified across various asset classes, key strategic locations across Delhi NCR, 
  and risk spectrum between delivered, nearing completion and under design. Max Estates in its pursuit of emerging as
   the most preferred brand in real estate in the NCR is driven by the desire to enhance well-being. `
}